import * as React from "react";
import swal from "sweetalert";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { ListItemSecondaryAction } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import { _get } from "../../Api";

const fetchData = (callback) => {
  _get("/nova/permissions/allusers")
    .then((res) => {
      callback(res.data);
    })
    .catch((e) => {
      callback(null, e);
    });
};

export default function AddUserToMerchant(props) {
  const [loading, setLoading] = React.useState(true);
  const [users, setUsers] = React.useState([]);
  const [selectedUsers, setSelectedUsers] = React.useState(
    props.selectedUsers ? props.selectedUsers.map((x) => x.email) : []
  );
  const [searchValue, setSearchValue] = React.useState("");

  const addUserToMerchant = (user) => {
    props.addSelectedUser(user);
    setSelectedUsers(props.selectedUsers.map((x) => x.email) || []);
  };

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };

  if (loading) {
    fetchData((res, err) => {
      if (err) {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
        return;
      }
      setLoading(false);
      setUsers(res);
    });
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div>
      <TextField style={{ margin: 10 }} label="Search" onChange={handleSearch} />

      <List>
        {users && users.length > 0
          ? users
              .filter((user) => user.email.includes(searchValue.toLowerCase()))
              .map((user) => {
                return (
                  <ListItem>
                    <ListItemText>{user.email}</ListItemText>
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="end"
                        onChange={() => addUserToMerchant(user)}
                        checked={selectedUsers.includes(user.email)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })
          : null}
      </List>
    </div>
  );
}
